/**
 * Injection-friendly translator for pure moderation mappers.
 * Domain helpers take `t` instead of calling i18n — they stay
 * framework-free and unit-testable without a provider.
 */
export type Translate = (key: string, fallback: string) => string;

/** First value that is neither nullish nor an empty string. */
export function firstNonEmpty(
  ...values: (string | null | undefined)[]
): string | undefined {
  return (
    values.find((value) => value !== null && value !== undefined && value !== '') ??
    undefined
  );
}
